<template>
  <van-button
    class="btn"
    :style="{
      height: height,
      background: bgcolor,
      color: btncolor,
      width: btnwidth,
      border: btnborder,
      margin: btnmargin,
      'line-height': height,
      'font-size': fontsize,
      'font-weight': fontweight,
      'border-radius': borderradius,
      'display': 'inline-block',
      'box-shadow': btnShadow, //'1px 5px 8px 0 rgba(249, 89, 27, 0.5)',
    }"
    @click="btnClick"
  >
    {{ btntext }}
  </van-button>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: "",
    },
    bgcolor: {
      type: String,
      default: "",
    },
    fontsize: {
      type: String,
      default: "", //1.6rem
    },
    fontweight: {
      type: Number,
      default: 400,
    },
    btncolor: {
      type: String,
      default: "",
    },
    btntext: {
      type: String,
      default: "",
    },
    borderradius: {
      type: String,
      default: "",
    },
    btnwidth: {
      type: String,
      default: "",
    },
    btnborder: {
      type: String,
      default: "none",
    },
    btnmargin: {
      type: String,
      default: "",
    },
    btnShadow: {
      type: String,
      default: "",
    },
  },
  methods: {
    btnClick() {
      this.$emit("btnClick");
    },
  },
};
</script>

<style scoped lang='less'>
.btn {
  text-align: center;
  padding: 0;
}
</style>